interface HTMLProps {
  html: string;
}

const transformImgSrc = (html: string) => {
  return html.replace(/<img[^>]*src="([^"]*)"[^>]*>/g, (match, src) => {
    return match.replace(/src="[^"]*"/, `src="${src}" width="480"`);
  });
};

export const HTML = ({ html }: HTMLProps) => {
  return <div dangerouslySetInnerHTML={{ __html: transformImgSrc(html) }} />;
};
